module.exports = __webpack_public_path__ + "static/assets/100bcb128958c29b1a9c4fb3597d4254.svg";